export const meta = {
  slug: { de: "praxisorganisation-verbessern", en: "improve-practice-organization" },
  title: "Praxisorganisation ruhig verbessern: ohne große Umstellungen",
  excerpt:
    "Bessere Praxisorganisation entsteht selten durch große Reformen. Sie wächst aus kleinen, klar gedachten Veränderungen im Alltag.",
  category: "praxen",
  publishedAt: "2026-04-11",
  updatedAt: "2026-05-06",
  metaTitle: "Praxisorganisation verbessern | OnePractix",
  metaDescription:
    "Praxisorganisation Schritt für Schritt verbessern – ohne große Umstellungen, mit Fokus auf ruhige Abläufe und klare Verantwortlichkeiten.",
  related: ["patientenanfragen-effizient-bearbeiten", "telefonservice-praxis-sinnvoll"],
  en: {
    title: "Improving practice organization calmly: without major upheaval",
    metaTitle: "Improving practice organization | OnePractix",
    metaDescription:
      "How to improve practice organisation step by step — without major upheaval, with focus on calm workflows and clear responsibilities.",
    excerpt:
      "Better practice organisation rarely emerges from large reforms. It grows out of small, clearly thought-through changes in everyday work.",
  },
};

export default meta;
